import { buttonBarCss, CeruleanButton, GrayButton } from 'components/Button'
import Row from 'components/Row'
import messages from 'lang'
import React from 'react'
import { injectIntl, WrappedComponentProps as _I } from 'react-intl'
import styled from 'styled-components'

import Container from '../Modal/Container'
import { PropsType as _P } from '.'

const Actions = styled(Row)`
  ${buttonBarCss};
`

type PropsType = _P & _I

const SignoutSessions = ({ hideModal, intl }: PropsType) => {
  return (
    <Container
      sub={intl.formatMessage(messages.sub_title_signout)}
      title={intl.formatMessage(messages.title_signout_sessions)}
    >
      <Actions grow={1}>
        <GrayButton e2e='cancelButton' onClick={hideModal} type='button'>
          {intl.formatMessage(messages.button_cancel)}
        </GrayButton>

        <CeruleanButton e2e='signoutButton' type='submit'>
          {intl.formatMessage(messages.button_signout)}
        </CeruleanButton>
      </Actions>
    </Container>
  )
}

export default injectIntl(SignoutSessions)
